import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Form, Row, Col, Button, Container, Alert } from 'react-bootstrap'
import { addItem } from '../actions/itemActions'
import { addName } from '../actions/nameActions'
import {
  addSettings,
  updateSettings,
  getSettings
} from '../actions/settingActions'
import Loader from '../components/Loader'
import Message from '../components/Message'

const Settings = () => {
  const [item, setItem] = useState('')
  const [manufacturer, setName] = useState('')
  const [taxrate, setTaxrate] = useState('')
  const [currency, setCurrency] = useState('')
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })

  function showAlert(message, variant = 'success', seconds = 1000) {
    setAlert({
      show: true,
      message,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  // Problem with cid when user is not logged in
  // const { cid } = userInfo

  const itemAdd = useSelector((state) => state.itemAdd)
  const { loading, error, success } = itemAdd

  const nameAdd = useSelector((state) => state.nameAdd)
  const {
    loading: loadingName,
    error: errorName,
    success: successName
  } = nameAdd

  const settingAdd = useSelector((state) => state.settingAdd)
  const {
    loading: loadingSetting,
    error: errorSetting,
    successadd
  } = settingAdd

  const settingList = useSelector((state) => state.settingList)
  const { settings } = settingList

  const onSubmit = (e) => {
    e.preventDefault()
    if (item) {
      const newitem = { item: item, cid: userInfo.cid }
      dispatch(addItem(newitem))
      showAlert('Item Added', 'success')
      setItem('')
    } else if (manufacturer) {
      dispatch(addName({ manufacturer, cid: userInfo.cid }))
      showAlert('Manufacturer Added', 'success')
      setName('')
    } else if (taxrate && currency) {
      dispatch(addSettings({ taxrate, currency, cid: userInfo.cid }))
      showAlert('Tax Rate and Currency Added', 'success')
      setTaxrate('')
      setCurrency('')
    }
  }

  const onSumbitUpdate = (e) => {
    e.preventDefault()

    if (taxrate && currency && settings) {
      dispatch(updateSettings({ taxrate, currency, _id: settings._id }))
      showAlert('Tax Rate and Currency Updated', 'success')
      setTaxrate('')
      setCurrency('')
    }
  }

  useEffect(() => {
    if (success) {
      dispatch({ type: 'ITEM_ADD_RESET' })
      navigate('/settings')
    } else if (successName && !errorName) {
      dispatch({ type: 'NAME_ADD_RESET' })
      navigate('/settings')
    }
  }, [dispatch, success, navigate, successName, errorName])

  useEffect(() => {
    if (!userInfo || userInfo.cid === undefined) {
      dispatch({ type: 'SETTING_LIST_RESET' })
      navigate('/login')
      window.location.reload()
    }
  }, [dispatch, navigate, userInfo])

  useEffect(() => {
    if (successadd) {
      dispatch(getSettings())
    }
  }, [dispatch, successadd])

  return (
    <Container>
      <h3 className='my-2'>Settings</h3>
      <hr />
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {error && <Message variant='danger'>{error}</Message>}
      {errorName && <Message variant='danger'>{errorName}</Message>}
      {errorSetting && <Message variant='danger'>{errorSetting}</Message>}
      {loading && <Loader />}
      {loadingName && <Loader />}
      {loadingSetting && <Loader />}
      {/* {loadinglist && <Loader />} */}
      <Form onSubmit={onSubmit}>
        <Row className='my-2'>
          <Col>
            <Form.Group controlId='newItem'>
              <Form.Label>Add New Item</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter New Item'
                value={item}
                onChange={(e) => setItem(e.target.value)}
              />
            </Form.Group>
            <Button type='submit' variant='primary' size='sm' className='my-2'>
              Save Item
            </Button>
          </Col>
          <Col>
            <Form.Group controlId='newName'>
              <Form.Label>Add New Manufacturer</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter New Manufacturer'
                value={manufacturer}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Button type='submit' variant='primary' size='sm' className='my-2'>
              Save Manufacturer
            </Button>
          </Col>
        </Row>
        <Row className='my-2'>
          <Col>
            <Form.Group controlId='setTaxrate'>
              <Form.Label>Set Tax Rate</Form.Label>
              <Form.Control
                type='number'
                min='0.01'
                step='0.01'
                placeholder='Enter Tax Rate %'
                className='w-50'
                value={taxrate}
                onChange={(e) => setTaxrate(e.target.value)}
              />
            </Form.Group>
            {settings ? (
              <Button
                type='submit'
                variant='primary'
                size='sm'
                className='my-2'
                onSubmit={onSumbitUpdate}
              >
                Update Tax and Currency
              </Button>
            ) : (
              <Button type='submit' className='btn btn-primary btn-sm my-2'>
                Save Tax Rate and Currency
              </Button>
            )}
          </Col>

          <Col>
            <Form.Group controlId='setCurrency'>
              <Form.Label>Set currency, e.g. CAD, USD, GBP ...</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter Currency'
                className='w-50'
                value={currency}
                onChange={(e) => setCurrency(e.target.value.toUpperCase())}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  )
}

export default Settings
